import React from "react";
import "./css/AboutUs.css";
import headerBg from "./assets/picOne.png"; // reuse or replace with a relevant image

const MalawiQualityAwards = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Malawi Quality Awards</h1>
          <p className="subtitle">
            The Malawi Bureau of Standards (MBS) recognizes excellence in quality and performance through the Malawi Quality Awards.
          </p>
          <p className="subtitle">
            These awards encourage organizations to adopt high standards, improve processes, and deliver exceptional products and services to consumers.
          </p>
        </div>
      </section>

      {/* === Awards Overview Section === */}
      <section className="intro-section">
        <h2 className="section-title">About the Awards</h2>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Recognizes organizations demonstrating outstanding quality management and standards compliance</li>
              <li>Encourages continuous improvement and innovation in products and services</li>
              <li>Promotes competitiveness and customer satisfaction in the marketplace</li>
              <li>Highlights excellence in operational efficiency and organizational practices</li>
              <li>Supports national quality culture and standards awareness</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Open to all sectors including manufacturing, services, and public institutions</li>
              <li>Assessment conducted by MBS experts based on internationally recognized criteria</li>
              <li>Recognition includes certificates, trophies, and public acknowledgment</li>
              <li>Encourages benchmarking and adoption of best practices across industries</li>
              <li>Fosters a culture of quality and excellence in Malawi</li>
            </ul>
          </div>
        </div>
      </section>

      {/* === Nomination & Evaluation Section === */}
      <section className="functions-section">
        <h2 className="section-title">Nomination & Evaluation</h2>
        <p>
          Organizations interested in participating can submit nominations according to MBS guidelines. 
          Evaluation is conducted by a panel of experts who assess performance, adherence to standards, and overall impact on quality.
        </p>
      </section>

      {/* === Contact Section === */}
      <section className="functions-section">
        <h2 className="section-title">Contact for Malawi Quality Awards</h2>
        <p>
          For inquiries, nomination submissions, or additional information about the Malawi Quality Awards, please contact the MBS Quality Awards team.
        </p>
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>Email: <a href="mailto:qualityawards@mbs.mw">qualityawards@mbs.mw</a></li>
              <li>Phone: +265 (0) 1 789 444</li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>Office: Malawi Bureau of Standards, P.O. Box 946, Blantyre, Malawi</li>
              <li>Website: <a href="https://www.mbs.mw">www.mbs.mw</a></li>
            </ul>
          </div>
        </div>
        <p className="subtitle">
          The Malawi Quality Awards celebrate excellence, encourage continuous improvement, and recognize organizations committed to delivering high-quality products and services.
        </p>
      </section>

      <br /><br />
    </div>
  );
};

export default MalawiQualityAwards;
